var _path, _path2;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSlash = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19C5.03535 19 1 14.9647 1 10C1 5.03535 5.03535 1 10 1C14.9647 1 19 5.03535 19 10C19 14.9647 14.9647 19 10 19ZM10 2.25581C5.73023 2.25581 2.25581 5.73023 2.25581 10C2.25581 14.2698 5.73023 17.7442 10 17.7442C14.2698 17.7442 17.7442 14.2698 17.7442 10C17.7442 5.73023 14.2698 2.25581 10 2.25581Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.62714 17C3.46773 17 3.30833 16.9413 3.18248 16.8155C2.93917 16.5722 2.93917 16.1695 3.18248 15.9263L14.9282 4.18245C15.1715 3.93918 15.5742 3.93918 15.8175 4.18245C16.0608 4.42571 16.0608 4.82836 15.8175 5.07162L4.0718 16.8155C3.94595 16.9413 3.78654 17 3.62714 17Z",
    fill: "#757575"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSlash, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/slash.bbc873f3.svg";
export { ForwardRef as ReactComponent };